import React, { Component } from 'react';
import { observer } from 'mobx-react';
import axios from 'axios';
import '@availity/yup';
import {
	Form,
	Field,
	FormGroup,
	Radio,
	RadioGroup,
	CheckboxGroup,
	Checkbox
} from '@availity/form';
import { SelectField, ResourceSelect } from '@availity/select';
import { DateField } from '@availity/date';
import AvApi from '@availity/api-axios';
import { Button, Label, Row, Col, UncontrolledTooltip, UncontrolledAlert } from 'reactstrap';
import * as yup from 'yup';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import CustomProgressBar from '../../Common/components/CustomProgressBar';
import awardeestore from '../stores/awardeestore';
import AmountCheckbox from './components/AmountCheckbox';
import AwardeeMiscExpense from './components/AwardeeMiscExpense';

@observer
export default class ProviderAndAwardee extends Component {
	constructor(props) {
		super(props);

		this.state = {
			redirectToLanding: false,
			redirectToDocuments: false,
			userInput: '',
			enableProviderAgency: false,
			showInfo: false
		}

		if (awardeestore.getUploadAwardeeHousingPageStatus('#providerAndAwardee') !== 'stepwizard-step active') {
			awardeestore.setUploadAwardeeHousingPageStatus('#providerAndAwardee', 'active');
		}

		if(window.performance) {
			if(performance.navigation.type == 1) {
        awardeestore.resetUploadAwardeeHousingPageStatus();
				window.location.href = '#';
			}
		}
		
	}

	componentDidMount() {

		axios.post('/ahahawardeeprofileform/wa/api/v1/provconn/provider/agency/lookup',
			{
				q: "verify",
				limit: 1,
				offset: 0,
				searchKey: "verify"
			})
				.then(res => {
					this.setState({ enableProviderAgency: true });
				}).catch(error => {
					if(error.response.status === 404){
						this.setState({ enableProviderAgency: false });
					}
				});
		window.onpopstate = () => {
			this.props.history.go(1);
		}
	}

	setProviderInformation = event => {
		const { name, value } = event.target;
		awardeestore.setProviderInfo(name, value);
	}


	setAwardeeProviderOneId = event => {
		const { value } = event.target;
		awardeestore.setAwardeeProvOne(value);
	}

	

	setAwardeeDOB = value => {
		awardeestore.setAwardeeDateOfBirth(value);
	}

	setAwardeeInformation = event => {
		const { name, value } = event.target;
		awardeestore.setAwardeeInfo(name, value);
	}
	
	goBack = () => {
		this.setState({ redirectToLanding: true });
	}

	submit = () => {
		awardeestore.completedSteps.providerAndAwardee = true;
		this.setState({ redirectToDocuments: true });
	}

	onChangeProvAgencyName = (selectedProvAgencyName) => {
		if (awardeestore.getAttachmentCount() && awardeestore.getProvAgencyName(awardeestore.providerInformation) != selectedProvAgencyName.label){
			awardeestore.resetAllDocumentObj();
			this.setState({showInfo: true});
		}
		if (selectedProvAgencyName) {
			awardeestore.setProviderInfo('provAgencyName', selectedProvAgencyName)
		}
	}

	render() {
		const { userAgent } = navigator;
		const {  redirectToLanding, userInput, enableProviderAgency, redirectToDocuments, showInfo } = this.state;
		const {
			uploadAwardeeHousingPages,
			providerInformation,
			awardeeInformation,
		} = awardeestore;

		const {
			agencyName,
			contactFirst,
			contactLast,
			contactEmail,
			contactPhone
		} = providerInformation;

		const {
			awardeeFirst,
			awardeeLast,
			awardeeDOB,
			awardeeProvOneId,
		} = awardeeInformation;

		const provAgencyNameApi = new AvApi({
			api: '',
			url: '/ahahawardeeprofileform/wa/api/v1/provconn/provider/agency/lookup',
			transformRequest: (options) => JSON.stringify(options),
		});

		if (redirectToLanding) {
			return <Redirect to='/' />
		}

		if (redirectToDocuments) {
			return <Redirect to='/documentsVoucher'/>
		}

		return (
			<>
				<div className='border-form'>
					<CustomProgressBar pages={uploadAwardeeHousingPages} />

					<div className='spacer-50' />

					<small className='required-fields'>*required</small>

					<div className='mt-5' />

					<h2 className='poppinsH2'>
						Provider &amp; Awardee
					</h2>

					<div className='spacer-50' />

					<Form
						initialValues={{
							provAgencyName: agencyName,
							provContactFirst: contactFirst,
							provContactLast: contactLast,
							provContactEmail: contactEmail,
							provContactPhone: contactPhone,
							awardeeInfoFirst: awardeeFirst,
							awardeeInfoLast: awardeeLast,
							awardeeDateOfBirth: awardeeDOB,
							awardeeProvOne: awardeeProvOneId,
						}}
						onSubmit={this.submit}
					validationSchema={yup.object().shape({
					provAgencyName: enableProviderAgency ? yup.object().required('Provider Agency Name is required.') : yup.string().required('Provider Agency Name is required'),
					provContactFirst: yup.string()
					.matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Provider Contact First Name should be alpha-numeric')
					.required('Provider Contact First Name is required'),
					provContactLast: yup.string()
					.matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Provider Contact Last Name should be alpha-numeric')
					.required('Provider Contact Last Name is required'),
					provContactEmail: yup.string()
					.matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Provider Contact Email should be standard email format (example@mail.com)')
					.required('Provider Contact Email is required'),
					provContactPhone: yup.string()
					.matches(/^\d{10}$/, 'Provider Contact Phone Number must be 10 digits with no hyphens')
					.required('Provider Contact Phone Number is required'),
					awardeeInfoFirst: yup.string()
					.matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Awardee First Name should be alpha-numeric')
					.required('Awardee First Name is required'),
					awardeeInfoLast: yup.string()
					.matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Awardee Last Name should be alpha-numeric')
					.required('Awardee Last Name is required'),
					awardeeInfoPrefName: yup.string()
					.matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Awardee Preferred Name should be alpha-numeric'),
					awardeeDateOfBirth: yup.date()
					.max(moment().subtract(16, 'years').format('MM/DD/YYYY'), 'Date of Birth must be at least 16 years old.')
					.required('Awardee Date of Birth is required')
					.typeError('Please enter in correct date format (MM/DD/YYYY)'),
					awardeeProvOne: yup.string()
					.min(9, 'Please enter 9 digits')
					.matches(/\d{9}/, 'Provider Id should be only 9 digits, no special characters or alphabets')
					.required('Provider One Id is required'),
					})}
					>
						<div className='spacer-50' />
						{showInfo  &&
							<Row className="pl-32 mt-3">
								<Col>
									<UncontrolledAlert color='danger' fade>
										<strong>
											Change in Provider Agency required all the docs to upload again..!
										</strong>
									</UncontrolledAlert>
								</Col>
							</Row>
						}
						
						<h5 className='poppinsH5'>
							Provider Information
						</h5>

						<Row className='spacer-rem'>
							<Col sm='4'>
							{ 
							enableProviderAgency ? 
								<ResourceSelect
									label={
										<>
											<Label id="provAgencyName-label" htmlFor="provAgencyName" aria-describedby="providerAgencyNameHelp">
												Provider Agency Name*
												<span id="provAgencyName-help" className="inline-help" />
											</Label>
											<div id="providerAgencyNameHelp">
												<small className='form-text text-muted prov-agency-name-help'>
													Enter minimum 3 characters and continue to enter to find the exact match.
												</small>
											</div>
											<UncontrolledTooltip target="provAgencyName-help" placement="right" innerClassName="text-left">
												Enter minimum 3 characters and continue to enter to find the exact match.
											</UncontrolledTooltip>
										</>
									}
									id="provAgencyNameId"
									name="provAgencyName"
									className='straighten-borders'
									placeholder="Select Provider Agency Name"
									onChange={this.onChangeProvAgencyName}
									resource={provAgencyNameApi}
									shouldSearch={(_inputValue) => _inputValue.length > 2}
									onInputChange={(searchInput) => this.setState({ userInput: searchInput })}
									parameters={{
										searchKey: `${userInput}`,
									}}
									waitUntilFocused
									getResult={(data) =>
										data.names.map((val) => ({
											value: val.id,
											label: val.name,
											abbr: val.abbr
										}))
									}
									method='POST'
								/>
								:
								<FormGroup htmlFor='provAgencyName' className='label-font'>
									<Label htmlFor='provAgencyName'>
										Provider Agency Name*
									</Label>
									<Field 
										type="text"
										id="provAgencyName"
										name="provAgencyName"
										className='straighten-borders'
										onChange={this.setProviderInformation}
										value={agencyName}
										maxLength={50}
									/>
								</FormGroup>
							}
							</Col>

							<Col sm='4' className='spacer-1halfrem'>
								<FormGroup for='provContactFirst' className='label-font'>
									<Label htmlFor='provContactFirst'>
										Provider Contact First Name*
									</Label>
									<Field
										type='text'
										id='provContactFirst'
										name='provContactFirst'
										className='straighten-borders'
										onChange={this.setProviderInformation}
										value={contactFirst}
										maxLength={50}
									/>
								</FormGroup>
							</Col>
							<Col sm='4' className='spacer-1halfrem'>
								<FormGroup for='provContactLast' className='label-font'>
									<Label htmlFor='provContactLast'>
										Provider Contact Last Name*
									</Label>
									<Field
										type='text'
										id='provContactLast'
										name='provContactLast'
										className='straighten-borders'
										onChange={this.setProviderInformation}
										value={contactLast}
										maxLength={50}
									/>
								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col sm='4'>
								<FormGroup for='provContactEmail' className='label-font'>
									<Label htmlFor='provContactEmail'>
										Provider Contact Email*
									</Label>
									<Field
										type='text'
										id='provContactEmail'
										name='provContactEmail'
										className='straighten-borders'
										onChange={this.setProviderInformation}
										value={contactEmail}
										maxLength={50}
									/>
								</FormGroup>
							</Col>
							<Col sm='4'>
								<FormGroup for='provContactPhone' className='label-font'>
									<Label htmlFor='provContactPhone'>
										Provider Contact Phone*
									</Label>
									<Field
										type='text'
										id='provContactPhone'
										name='provContactPhone'
										className='straighten-borders'
										onChange={this.setProviderInformation}
										value={contactPhone}
										maxLength={10}
									/>
								</FormGroup>
							</Col>
						</Row>

						<hr />

						<h5 className='poppinsH5'>
							Awardee 
						</h5>

						<Row className='spacer-rem'> 
							<Col sm='4'>
								<FormGroup for='awardeeInfoFirst' className='label-font'>
									<Label htmlFor='awardeeInfoFirst'>
										First Name*
									</Label>
									<Field
										type='text'
										id='awardeeInfoFirst'
										name='awardeeInfoFirst'
										className='straighten-borders'
										onChange={this.setAwardeeInformation}
										value={awardeeFirst}
										maxLength={50}
									/>
								</FormGroup>
							</Col>
							<Col sm='4'>
								<FormGroup for='awardeeInfoLast' className='label-font'>
									<Label htmlFor='awardeeInfoLast'>
										Last Name*
									</Label>
									<Field
										type='text'
										id='awardeeInfoLast'
										name='awardeeInfoLast'
										className='straighten-borders'
										onChange={this.setAwardeeInformation}
										value={awardeeLast}
										maxLength={50}
									/>
								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col sm='3'>
								<FormGroup for='awardeeDateOfBirth' className='label-font'>
									<DateField
										id='awardeeDateOfBirth'
										name='awardeeDateOfBirth'
										label='Date of Birth*'
										value={awardeeDOB}
										className='straighten-borders'
										onChange={this.setAwardeeDOB}
										datePickerProps={{
										    showDefaultInputIcon: true,
											inputIconPosition: 'after',
											autoComplete: /edg/i.test(userAgent) ? 'autofill-off-edge' : 'off',
										}}
									/>
								</FormGroup>
							</Col>
							<Col className='pr-0' sm='3'>
								<FormGroup for='awardeeProvOne' className='label-font'>
									<Field
										type="text"
										name="awardeeProvOne"
										id="awardeeProvOne"
										className="straighten-borders"
										label="ProviderOne ID*"
										value={awardeeProvOneId}
										onChange={this.setAwardeeProviderOneId}
										maxLength={9}
									/>
								</FormGroup>
							</Col>
							<Col className='pl-0' sm='1'>
								<FormGroup for='wash_suffix' className='label-font'>
									<Field
										type='text'
										id='wash_suffix'
										aria-label='wash-suffix'
										name='wash_suffix'
										className='straighten-borders stateCode-suffix'
										value='WA'
										disabled
									/>
								</FormGroup>
							</Col>
						</Row>
	
						<Button type="button" color={"primary"} className={'btn btn-primary straighten-borders buttonBack'} onClick={this.goBack}>
							Back
						</Button>
						<Button type="submit" color={"primary"} className={'btn btn-primary awardeeNextBtn mb-50'}>
							Next
						</Button>
					</Form>
				</div>
				<div className='pb-spacer9hRem' />
			</>
		);
	}
}

ProviderAndAwardee.propTypes = {
	history: PropTypes.object
}